// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.0
//   protoc               unknown
// source: qonto/account_management/users/firstparty/v5/send_email_otp.proto

/* oxlint-disable */

/** Request message for SendEmailOtp (POST /v5/user/email_update/send_otp). */
export interface ApiSendEmailOtpRequest {
  /** New email address to send the OTP to. */
  readonly pendingEmail: string;
  /**
   * Whether to confirm migration of all memberships from old email to new email.
   * If the user has more than one membership, not sending true will result in failure
   */
  readonly confirmMigration?: boolean | null | undefined;
}

/** Response message for SendEmailOtp (204 No Content on success). */
export interface ApiSendEmailOtpResponse {
}

/** Error codes for SendEmailOtp. */
export interface ApiSendEmailOtpErrors {
}

/** HTTP 422 Unprocessable Entity errors. */
export const ApiSendEmailOtpErrorsUnprocessableEntityError = {
  /** UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED - Default unspecified value. */
  UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED: "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED",
  /** UNPROCESSABLE_ENTITY_ERROR_FAILED_VALIDATION - Generic validation failure. */
  UNPROCESSABLE_ENTITY_ERROR_FAILED_VALIDATION: "UNPROCESSABLE_ENTITY_ERROR_FAILED_VALIDATION",
  /** UNPROCESSABLE_ENTITY_ERROR_INVALID_EMAIL_FORMAT - Provided email address has an invalid format. */
  UNPROCESSABLE_ENTITY_ERROR_INVALID_EMAIL_FORMAT: "UNPROCESSABLE_ENTITY_ERROR_INVALID_EMAIL_FORMAT",
  /** UNPROCESSABLE_ENTITY_ERROR_REQUIRED_DIFFERENT_EMAIL - Provided email address is the same as the current one. */
  UNPROCESSABLE_ENTITY_ERROR_REQUIRED_DIFFERENT_EMAIL: "UNPROCESSABLE_ENTITY_ERROR_REQUIRED_DIFFERENT_EMAIL",
} as const;

export type ApiSendEmailOtpErrorsUnprocessableEntityError =
  typeof ApiSendEmailOtpErrorsUnprocessableEntityError[keyof typeof ApiSendEmailOtpErrorsUnprocessableEntityError];

export namespace ApiSendEmailOtpErrorsUnprocessableEntityError {
  export type UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED =
    typeof ApiSendEmailOtpErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED;
  export type UNPROCESSABLE_ENTITY_ERROR_FAILED_VALIDATION =
    typeof ApiSendEmailOtpErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_FAILED_VALIDATION;
  export type UNPROCESSABLE_ENTITY_ERROR_INVALID_EMAIL_FORMAT =
    typeof ApiSendEmailOtpErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_INVALID_EMAIL_FORMAT;
  export type UNPROCESSABLE_ENTITY_ERROR_REQUIRED_DIFFERENT_EMAIL =
    typeof ApiSendEmailOtpErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_REQUIRED_DIFFERENT_EMAIL;
}

export function apiSendEmailOtpErrorsUnprocessableEntityErrorFromJSON(
  object: any,
): ApiSendEmailOtpErrorsUnprocessableEntityError {
  switch (object) {
    case 0:
    case "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED":
      return ApiSendEmailOtpErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED;
    case 1:
    case "UNPROCESSABLE_ENTITY_ERROR_FAILED_VALIDATION":
      return ApiSendEmailOtpErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_FAILED_VALIDATION;
    case 2:
    case "UNPROCESSABLE_ENTITY_ERROR_INVALID_EMAIL_FORMAT":
      return ApiSendEmailOtpErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_INVALID_EMAIL_FORMAT;
    case 3:
    case "UNPROCESSABLE_ENTITY_ERROR_REQUIRED_DIFFERENT_EMAIL":
      return ApiSendEmailOtpErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_REQUIRED_DIFFERENT_EMAIL;
    default:
      return ApiSendEmailOtpErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED;
  }
}

export function apiSendEmailOtpErrorsUnprocessableEntityErrorToJSON(
  object: ApiSendEmailOtpErrorsUnprocessableEntityError,
): string {
  switch (object) {
    case ApiSendEmailOtpErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED:
      return "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED";
    case ApiSendEmailOtpErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_FAILED_VALIDATION:
      return "UNPROCESSABLE_ENTITY_ERROR_FAILED_VALIDATION";
    case ApiSendEmailOtpErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_INVALID_EMAIL_FORMAT:
      return "UNPROCESSABLE_ENTITY_ERROR_INVALID_EMAIL_FORMAT";
    case ApiSendEmailOtpErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_REQUIRED_DIFFERENT_EMAIL:
      return "UNPROCESSABLE_ENTITY_ERROR_REQUIRED_DIFFERENT_EMAIL";
    default:
      return "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED";
  }
}

/** HTTP 428 Precondition Required errors. */
export const ApiSendEmailOtpErrorsPreconditionRequiredError = {
  /** PRECONDITION_REQUIRED_ERROR_UNSPECIFIED - Default unspecified value. */
  PRECONDITION_REQUIRED_ERROR_UNSPECIFIED: "PRECONDITION_REQUIRED_ERROR_UNSPECIFIED",
  /** PRECONDITION_REQUIRED_ERROR_REQUIRED_MIGRATION_CONFIRMATION - Migration confirmation required before sending OTP to new email. */
  PRECONDITION_REQUIRED_ERROR_REQUIRED_MIGRATION_CONFIRMATION:
    "PRECONDITION_REQUIRED_ERROR_REQUIRED_MIGRATION_CONFIRMATION",
  /** PRECONDITION_REQUIRED_ERROR_NEW_USER_IS_NOT_SCA_ENROLLED - The new user is not enrolled in SCA. */
  PRECONDITION_REQUIRED_ERROR_NEW_USER_IS_NOT_SCA_ENROLLED: "PRECONDITION_REQUIRED_ERROR_NEW_USER_IS_NOT_SCA_ENROLLED",
} as const;

export type ApiSendEmailOtpErrorsPreconditionRequiredError =
  typeof ApiSendEmailOtpErrorsPreconditionRequiredError[keyof typeof ApiSendEmailOtpErrorsPreconditionRequiredError];

export namespace ApiSendEmailOtpErrorsPreconditionRequiredError {
  export type PRECONDITION_REQUIRED_ERROR_UNSPECIFIED =
    typeof ApiSendEmailOtpErrorsPreconditionRequiredError.PRECONDITION_REQUIRED_ERROR_UNSPECIFIED;
  export type PRECONDITION_REQUIRED_ERROR_REQUIRED_MIGRATION_CONFIRMATION =
    typeof ApiSendEmailOtpErrorsPreconditionRequiredError.PRECONDITION_REQUIRED_ERROR_REQUIRED_MIGRATION_CONFIRMATION;
  export type PRECONDITION_REQUIRED_ERROR_NEW_USER_IS_NOT_SCA_ENROLLED =
    typeof ApiSendEmailOtpErrorsPreconditionRequiredError.PRECONDITION_REQUIRED_ERROR_NEW_USER_IS_NOT_SCA_ENROLLED;
}

export function apiSendEmailOtpErrorsPreconditionRequiredErrorFromJSON(
  object: any,
): ApiSendEmailOtpErrorsPreconditionRequiredError {
  switch (object) {
    case 0:
    case "PRECONDITION_REQUIRED_ERROR_UNSPECIFIED":
      return ApiSendEmailOtpErrorsPreconditionRequiredError.PRECONDITION_REQUIRED_ERROR_UNSPECIFIED;
    case 1:
    case "PRECONDITION_REQUIRED_ERROR_REQUIRED_MIGRATION_CONFIRMATION":
      return ApiSendEmailOtpErrorsPreconditionRequiredError.PRECONDITION_REQUIRED_ERROR_REQUIRED_MIGRATION_CONFIRMATION;
    case 2:
    case "PRECONDITION_REQUIRED_ERROR_NEW_USER_IS_NOT_SCA_ENROLLED":
      return ApiSendEmailOtpErrorsPreconditionRequiredError.PRECONDITION_REQUIRED_ERROR_NEW_USER_IS_NOT_SCA_ENROLLED;
    default:
      return ApiSendEmailOtpErrorsPreconditionRequiredError.PRECONDITION_REQUIRED_ERROR_UNSPECIFIED;
  }
}

export function apiSendEmailOtpErrorsPreconditionRequiredErrorToJSON(
  object: ApiSendEmailOtpErrorsPreconditionRequiredError,
): string {
  switch (object) {
    case ApiSendEmailOtpErrorsPreconditionRequiredError.PRECONDITION_REQUIRED_ERROR_UNSPECIFIED:
      return "PRECONDITION_REQUIRED_ERROR_UNSPECIFIED";
    case ApiSendEmailOtpErrorsPreconditionRequiredError.PRECONDITION_REQUIRED_ERROR_REQUIRED_MIGRATION_CONFIRMATION:
      return "PRECONDITION_REQUIRED_ERROR_REQUIRED_MIGRATION_CONFIRMATION";
    case ApiSendEmailOtpErrorsPreconditionRequiredError.PRECONDITION_REQUIRED_ERROR_NEW_USER_IS_NOT_SCA_ENROLLED:
      return "PRECONDITION_REQUIRED_ERROR_NEW_USER_IS_NOT_SCA_ENROLLED";
    default:
      return "PRECONDITION_REQUIRED_ERROR_UNSPECIFIED";
  }
}

export const ApiSendEmailOtpRequest: MessageFns<ApiSendEmailOtpRequest> = {
  fromJSON(object: any): ApiSendEmailOtpRequest {
    return {
      pendingEmail: isSet(object.pending_email) ? globalThis.String(object.pending_email) : "",
      confirmMigration: isSet(object.confirm_migration) ? globalThis.Boolean(object.confirm_migration) : null,
    };
  },

  toJSON(message: ApiSendEmailOtpRequest): unknown {
    const obj: any = {};
    if (message.pendingEmail !== undefined && message.pendingEmail !== null) {
      obj.pending_email = message.pendingEmail;
    }
    if (message.confirmMigration !== undefined && message.confirmMigration !== null) {
      obj.confirm_migration = message.confirmMigration;
    }
    return obj;
  },
};

export const ApiSendEmailOtpResponse: MessageFns<ApiSendEmailOtpResponse> = {
  fromJSON(_: any): ApiSendEmailOtpResponse {
    return {};
  },

  toJSON(_: ApiSendEmailOtpResponse): unknown {
    const obj: any = {};
    return obj;
  },
};

export const ApiSendEmailOtpErrors: MessageFns<ApiSendEmailOtpErrors> = {
  fromJSON(_: any): ApiSendEmailOtpErrors {
    return {};
  },

  toJSON(_: ApiSendEmailOtpErrors): unknown {
    const obj: any = {};
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
